var CONSTANTS = {
    urlPrefix: URL_PREFIX,
    authUrl: AUTH_SERVER,
    cdnUrl: CDN_SERVER,
    callCenterUrl: CALL_CENTER_SERVER,
    trackingUrl: TRACKING_SERVER,
    coreUrl: CORE_SERVER,
    efpUrl: EFP_SERVER,
    socketUrl: SOCKET_API,
};
export { CONSTANTS };
//# sourceMappingURL=index.js.map